<template>
  <div>
    <b-card header="Validaciones de Participación"
        :key="key"
        class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showValidacionesParticipacion= !showValidacionesParticipacion">
        <i :class="showValidacionesParticipacion ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-btn class="card-header-add" 
          v-if="showValidacionesParticipacion & !participacionValidada"
          variant="primary" 
          size="sm"
          @click.prevent="validarParticipacion">
        <i class="fa fa-plus"></i>
      </b-btn>
      <b-collapse class="mt-2" v-model="showValidacionesParticipacion">
        <b-table 
            class="registro validaciones" 
            responsive="sm" 
            :items="validaciones" 
            :fields="fieldsValidaciones">
          <template v-slot:cell(fechaRegistro)="data">
            {{ data.item.fechaRegistro | fechaHora }}
          </template>
          <template v-slot:cell(validacionAprobada)="data">
            {{ data.item.validacionAprobada? 'Si' : 'No' }}
          </template>
          <template v-slot:cell(opciones)="data">
            <b-dropdown v-if="borrarHabilitado" variant="link" toggle-class="text-decoration-none" no-caret>
              <template slot="button-content">
                <i class="fa fa-ellipsis-v"></i>
              </template>
              <b-dropdown-item @click.stop="borrarValidacionParticipacion(data.item)">
                <i class="fa fa-close"></i>Borrar Validación</b-dropdown-item>
            </b-dropdown>
          </template>

          <template v-slot:cell(detailShowing)="row">
            <b-btn class="detailShowing" 
                size="sm" 
                v-if="row.item.observaciones != ''" 
                @click.stop="row.toggleDetails">
              {{ ( row.detailShowing) ? '-' : '+' }}
            </b-btn>            
          </template>

          <template slot="row-details" slot-scope="row">
            <b-row>
              <b-col cols="12">
                <p class="descripcion">{{ row.item.observaciones }}</p>
              </b-col>
            </b-row>
          </template>
        </b-table>
      </b-collapse>
    </b-card>

    <b-modal ref="validacionModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM">
      <app-validacion
        :eventoId="eventoId"
        :participanteId="participanteId"
        :eventoEtapaId="eventoEtapaId"
        :validacionIdentidad="false"
        @close="closeValidacion">
      </app-validacion>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Validacion from  '../validaciones/ABM.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'participanteDatos/getField',
  mutationType: 'participanteDatos/updateField',
});

export default {
  name: 'ParticipanteDatosValidacionesParticipacion',
  components: {
    appValidacion: Validacion,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  props: {
    eventoEtapaId: {
      type: Number,
      default: 0
    }
  },
  data: () => {
    return {
      fieldsValidaciones: [
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        {
          key: 'fechaRegistro',
          label: 'Fecha'
        },
        {
          key: 'validacionAprobada',
          label: 'Aprobado'
        },
        {key: 'usuario'},
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      showValidacionesParticipacion: false,

      borrarHabilitado: false,
      key: 200,
    }
  },
  computed: {
    ...mapFields([
      'eventoId',
      'participanteId',
      'validacionesParticipacion'
    ]),
    validaciones() {
      if (this.validacionesParticipacion) {
        if (this.validacionesParticipacion.length != 0) {
          if (this.eventoEtapaId != 0) {
            return this.validacionesParticipacion.filter(validacion => validacion.eventoEtapaId == this.eventoEtapaId);
          } else {
            return this.validacionesParticipacion;
          }
        }
      }
      return null;
    },
    participacionValidada() {
      if (this.validacionesParticipacion) {
        if (this.validacionesParticipacion.length != 0) {
          if (this.eventoEtapaId != 0) {
            let participacionValidada = this.validacionesParticipacion
              .filter(validacion => validacion.eventoEtapaId == this.eventoEtapaId)
              .find(validacion => (/true/i).test(validacion.validacionAprobada));
            
            if (participacionValidada) {
              return true;
            }
          } else {
            let participacionValidada = this.validacionesParticipacion
              .find(validacion => (/true/i).test(validacion.validacionAprobada));
            
            if (participacionValidada) {
              return true;
            }
          }
        }
      }
      return false;
    }
  },
  created() {
    if ((/true/i).test(this.$store.getters['user/admin'])) {
      this.borrarHabilitado = true;
    }
  },  
  methods: {
    refresh() {
      this.key++;
    },
    validarParticipacion() {
      this.$refs.validacionModal.show();
    }, 
    closeValidacion(saved) {
      this.$refs.validacionModal.hide();
      if (saved) {
        this.$store.dispatch('participanteDatos/getValidacionesParticipacion')
          .catch( error => this.showErrorMsj (error));
      }
    },
    borrarValidacionParticipacion(item) {
      this.showModalConfirm('¿Desea borrar la validación seleccionada?', 
        this.borrarValidacionParticipacionSeleccionada.bind(this, item.id), 'Si', null, 'No')
    }, 
    borrarValidacionParticipacionSeleccionada(validacionId) {
      this.showSpinner();
      this.$store.dispatch('participanteDatos/deleteValidacionParticipacion', validacionId)
        .then(() => {
          this.showModalMsj('La validación seleccionada se borró con éxito.', null, null, 'light')
          this.$store.dispatch('participanteDatos/getValidacionesParticipacion');
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    }, 
  },
  watch: {
  }   
}
</script>

<style>
  .registro.validaciones table th {
    border-top: none;
  }
  .registro.validaciones table td {
    padding-top: 10px;
    padding-bottom: 5px;
  }
  .registro.validaciones table td[aria-colindex="1"] {
    width: 40px;
  }
  .registro.validaciones table td[aria-colindex="1"] button {
    position: relative;
    top: -5px;
  }
  .registro.validaciones table td[aria-colindex="2"] {
    width: 20%;
  }
  .registro.validaciones table td[aria-colindex="3"] {
    width: 10%;
  }
  .registro.validaciones table td[aria-colindex="4"] {
    width: calc(70% - 100px);
  }
  .registro.validaciones table td[aria-colindex="5"] {
    width: 60px;
  }

  .registro.validaciones table p.descripcion {
    margin-bottom: 5px;
    padding-left: 40px;
    width: calc(90% - 40px);
    white-space: pre-wrap;
  }
</style>